import { IconProps } from "../icon-props-interface";
import "../icons.scss";
import "./icon-processing.scss";

export const IconProcessing = (): JSX.Element => (
    <div className="icon-block icon-processing">
        <div className="icon-processing__canvas">
            <span className="icon-processing__ripple" aria-hidden="true" />
            <span
                className="icon-processing__ripple icon-processing__ripple--delayed"
                aria-hidden="true"
            />
            <span className="icon-processing__core" aria-hidden="true" />
        </div>
    </div>
);

export default IconProcessing;
